import type { HILinkInfo } from '../model/hi-link';

import type { AxiosRequestConfig } from 'axios';
import { monitoringInstance } from '@/shared/api/api-instances/monitoring/api-instance';

const baseURLOverride = {
  baseURL: '/api/monitoring/v4',
};

export class HitsCitsAPI {
  static getTQLHiTypesByCIT(cit_name: string, options?: AxiosRequestConfig) {
    return monitoringInstance.get<HILinkInfo[]>(
      `/hi/tql_links/ci_type/${cit_name}`,
      { ...options, ...baseURLOverride },
    );
  }

  static deleteHitCit(cit_id: string, options: AxiosRequestConfig = {}) {
    return monitoringInstance.delete(`/hi/link/${cit_id}`, options);
  }

  static deleteDependsWithHitCit(
    hit_cit_id: string,
    options: AxiosRequestConfig = {},
  ) {
    return monitoringInstance.delete(`/hi/link/depends/${hit_cit_id}`, options);
  }
}